import { render, staticRenderFns } from "./CompanyPresentationSwiper.vue?vue&type=template&id=1e98eeed&scoped=true&"
import script from "./CompanyPresentationSwiper.vue?vue&type=script&lang=js&"
export * from "./CompanyPresentationSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPresentationSwiper.vue?vue&type=style&index=0&id=1e98eeed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e98eeed",
  null
  
)

export default component.exports